import { Reveal } from './Reveal';

export const Manifesto = () => (
    <section className="py-20 px-6 border-b border-ink/10" data-testid="manifesto-section">
        <Reveal className="max-w-[1080px] mx-auto">
            <span className="font-serif italic text-6xl md:text-7xl text-rose leading-none block mb-6 select-none">"</span>
            <blockquote className="font-serif italic font-normal text-[clamp(1.4rem,3.2vw,2.1rem)] leading-[1.3] text-ink max-w-[760px]" data-testid="manifesto-quote">
                “Quiero ayudarte a convertirte en tu mejor versión y, sobre todo, a descubrir lo fuerte que eres y todo
                lo que puedes lograr. Que tu transformación sea un proceso real, sostenible y que puedas disfrutarlo.”
                <cite className="block mt-6 not-italic font-sans text-sm font-bold uppercase tracking-[0.05em] text-rose" data-testid="manifesto-signature">
                    — Adri
                </cite>
            </blockquote>
        </Reveal>
    </section>
);
